// @ts-check
/* eslint-env browser */

import { reactiveStore } from '../reactive-store.js'

export class SnapToggle extends HTMLElement {
  connectedCallback () {
    this.#setupClickHandlers()

    // Show/hide based on tileType
    reactiveStore.tileType.subscribe((/** @type string */ tileType) => {
      this.classList.toggle('govuk-!-display-none', tileType !== 'os')
    })

    // Set initial visibility state
    const initialTileType = reactiveStore.tileType.get()
    this.classList.toggle('govuk-!-display-none', initialTileType !== 'os')

    // Sync checkbox with reactiveStore.snap
    reactiveStore.snap.subscribe((/** @type boolean */ snap) => {
      /** @type {HTMLInputElement | null} */
      const checkbox = this.querySelector('input[type="checkbox"]')
      if (checkbox) {
        checkbox.checked = snap
      }
    })
  }

  /**
   * Updates reactiveStore.snap when checkbox is clicked
   */
  #setupClickHandlers () {
    /** @type {HTMLInputElement | null} */
    const checkbox = this.querySelector('input[type="checkbox"]')
    if (checkbox) {
      checkbox.addEventListener('change', () => {
        reactiveStore.snap.set(checkbox.checked)
      })
    }
  }
}

customElements.define('snap-toggle', SnapToggle)
